import { useState } from 'react';
import { Button, ButtonProps, CircularProgress, Tooltip } from '@mui/material';

import { Icon } from './Icon';
import { UserRoles } from '@lifeserver/shared';

import { useIsAuthorized } from '../hooks/useIsAuthorized';

interface ProtectedButtonProps extends ButtonProps {
    role: UserRoles;
}

export function ProtectedButton({
    role,
    ...buttonProps
}: ProtectedButtonProps) {
    const authorization = useIsAuthorized(role);
    const [feedbackMessage, setFeedbackMessage] = useState<string>();

    return (
        <Tooltip
            open={Boolean(feedbackMessage)}
            onClose={() => setFeedbackMessage(undefined)}
            title={feedbackMessage}
            disableHoverListener
            disableTouchListener
        >
            <Button
                {...buttonProps}
                disabled={authorization.isLoading || buttonProps.disabled}
                onClick={(e) => {
                    if (authorization.isAuthorized) {
                        buttonProps.onClick?.(e);
                    } else {
                        setFeedbackMessage(
                            `Access restricted to users with role '${role}'`,
                        );
                    }
                }}
                startIcon={
                    authorization.isLoading ? (
                        <CircularProgress />
                    ) : !authorization.isAuthorized ? (
                        <Icon name="lock" />
                    ) : (
                        buttonProps.startIcon
                    )
                }
            />
        </Tooltip>
    );
}
